import React from "react";

const NotFound = () => {
  return (
    <div>
      <img
        className="min-w-96"
        src="https://i.ibb.co/wBQQjRc/6333070.jpg"
        alt=""
      />
    </div>
  );
};

export default NotFound;
